import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'rk-notification-form-header',
  templateUrl: './notification-form-header.component.html',
  styleUrls: ['./notification-form-header.component.scss'],
  standalone: false,
})
export class NotificationFormHeaderComponent {
  @Output() readonly closeClick = new EventEmitter<void>();

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
